import { render } from "./Registration.vue?vue&type=template&id=19fd6d08&scoped=true"
import script from "./Registration.vue?vue&type=script&lang=js"
export * from "./Registration.vue?vue&type=script&lang=js"

import "./Registration.vue?vue&type=style&index=0&id=19fd6d08&scoped=true&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/deguild-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19fd6d08"]])

export default __exports__